import { useLayoutEffect, useRef } from "react"
import SecondaryText from "../../../components/general/BaseOutlineText"
import BaseBigText from "../../../components/general/BaseBigText"
import BaseSection from "../../../components/layout/BaseSection"
import gsap from "gsap"
import { useGSAP } from "@gsap/react"
import { ScrollTrigger } from "gsap/all"
import PainPointCard from "./PainPointCard"

type WicodeVerticalType = {
    problem_card: {
        number: string
        text: string
    }[]
}

export default function WicodeVertical(props: WicodeVerticalType) {
    const painPointRef = useRef<HTMLDivElement | null>(null)
    const painPointStartRef = useRef<HTMLDivElement | null>(null)
    const painPointEndRef = useRef<HTMLDivElement | null>(null)

    // ScrollTrigger to Fix the Left Part
    useLayoutEffect(() => {
        const ctx = gsap.context((self) => {
            if (window.innerWidth < 1024) return;
            ScrollTrigger.create({
                trigger: painPointStartRef.current,
                endTrigger: painPointEndRef.current,
                pin: true,
                start: "top top",
                end: "bottom bottom",
                pinSpacing: false,
            })
        })
        return () => ctx.revert()
    })

    useGSAP(
        () => {
            if (!painPointRef.current) return

            const boxes = gsap.utils.toArray<HTMLDivElement>(".painPointElement")

            boxes.forEach((box, index) => {
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: box,
                        start: "top 80%", // Starts when element enters viewport
                        end: "top 8%", // Ends when element leaves viewport
                        scrub: true
                        // markers: true, // Enable for debugging
                    },
                })

                // Entrance animation
                tl.from(box, {
                    opacity: 0,
                    y: 128,
                    x: 128,
                    rotationZ: -8,
                    ease: "power2.out",
                })

                // Exit animation
                tl.to(box, {
                    opacity: 0.5,
                    y: -128,
                    x: 128,
                    rotationZ: 8,
                    ease: "power2.in",
                })
            })
        },
        { scope: painPointRef }
    )

    return (
        <>
            <BaseSection paddings="" height="">
                <div ref={painPointStartRef} className="h-full min-h-screen sm:w-1/5 lg:w-0" />
                {/* PART LEFT */}
                <div ref={painPointStartRef} className="hidden lg:flex flex-col w-1/2 h-screen justify-center">
                    <div className="flex items-end -mb-6">
                        <SecondaryText text="W" weight="medium" textSize="text-[4.5rem]" classProps="flex justify-end items-end -mb-[1.1rem] -mr-1" />
                        <BaseBigText label={"as erzeugt"} textSize="text-6xl" />
                    </div>
                    <div className="flex items-end -mb-6">
                        <SecondaryText text="I" weight="medium" textSize="text-[4.5rem]" classProps="flex justify-end pl-6 items-end -mb-[1.1rem] -mr-1" />
                        <BaseBigText label={"n Unternehmen"} textSize="text-6xl" />
                    </div>
                    <div className="flex items-end -mb-6">
                        <SecondaryText text="C" weight="medium" textSize="text-[4.5rem]" classProps="flex justify-end pl-2 items-end -mb-[1.1rem] -mr-1" />
                        <BaseBigText label={"haos?"} textSize="text-6xl" />
                    </div>
                    <div className="flex items-end -mb-6">
                        <SecondaryText text="O" weight="medium" textSize="text-[4.5rem]" classProps="flex justify-end pl-2 items-end -mb-[1.1rem] -mr-1" />
                        <BaseBigText label={"b Sie"} textSize="text-6xl" />
                    </div>
                    <div className="flex items-end -mb-6">
                        <SecondaryText text="D" weight="medium" textSize="text-[4.5rem]" classProps="flex justify-end pl-3 items-end -mb-[1.1rem] -mr-1" />
                        <BaseBigText label={"iese Probleme"} textSize="text-6xl" />
                    </div>
                    <div className="flex items-end -mb-6">
                        <SecondaryText text="E" weight="medium" textSize="text-[4.5rem]" classProps="flex justify-end pl-3 items-end -mb-[1.1rem] -mr-1" />
                        <BaseBigText label={"benfalls"} textSize="text-6xl" />
                        <BaseBigText label={"kennen?"} textSize="text-6xl" classProps="ml-4" />
                    </div>
                </div>
                {/* PART RIGHT */}
                <div ref={painPointRef} className="flex flex-col lg:w-1/2 h-fit gap-8 py-40 sm:py-80">
                    {props.problem_card?.map((item) => (
                        <PainPointCard key={item.number} text={item.text} number={item.number} />
                    ))}
                </div>
            </BaseSection>
            <div ref={painPointEndRef} />
        </>
    )
}
